export enum EntityType {
	PROJECT = 'PROJECT',
	PHASE = 'PHASE',
	TASK = 'TASK',
	TIME_REG = 'TIME_REG',
}

export enum CustomFieldType {
	STRING = 'STRING',
	DROPDOWN = 'DROPDOWN',
	INTEGER = 'INTEGER',
}

export const EntityTypeLabels: Record<EntityType, string> = {
	[EntityType.PROJECT]: 'Project',
	[EntityType.PHASE]: 'Phase',
	[EntityType.TASK]: 'Task',
	[EntityType.TIME_REG]: 'Time Entry',
};

export const CustomFieldTypeLabels: Record<CustomFieldType, string> = {
	[CustomFieldType.STRING]: 'Free Text',
	[CustomFieldType.DROPDOWN]: 'Dropdown',
	[CustomFieldType.INTEGER]: 'Integer',
};

export const FF_GATED_CUSTOM_FIELD_TYPES: ReadonlySet<CustomFieldType> = new Set([CustomFieldType.INTEGER]);
